import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom'; // import useLocation
import NavbarMain from "./NavbarMain";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation(); // دریافت location

  useEffect(() => {
    window.scrollTo(0, 0); // ریست کردن موقعیت اسکرول
  }, [location.pathname]); // افزودن وابستگی

  return (
    <div>
      <NavbarMain /> {/* نوار ناوبری */}
      <Outlet /> {/* محتوای صفحات فرزند */}
      <Footer /> {/* فوتر */}
    </div>
  );
};

export default Layout;
